import * as yup from 'yup'

const schema = () =>
  yup.object().shape({
    name: yup
      .string()
      .required('Nome é obrigatório')
      .max(255, 'Nome deve ter no máximo 255 caracteres'),
    description: yup
      .string()
      .max(1000, 'Descrição deve ter no máximo 1000 caracteres'),
  })

export default schema
